import get from 'lodash/get';
import head from 'lodash/head';

import { DEPENDENT_STATUSES } from '../../../constants/props';
import { TODO_STATUSES } from '../../../constants';

export function printListTitle({
  upcomingCounter,
  formatMessage,
  upcomingTab,
  completedTab,
  historyAvailable,
}) {
  if (upcomingCounter === 0 && historyAvailable) {
    return {
      text: formatMessage({ id: 'healthboard.action.seeCompleted' }),
      tab: completedTab,
    };
  }
  if (upcomingCounter > 3 || historyAvailable) {
    return {
      text: formatMessage({ id: 'communities.title.seeAll' }),
      tab: upcomingTab,
    };
  }

  return {};
}

export function getSurveyEmptyBlockData(
  dependentStatus,
  upcomingCounter,
  completedCounter,
  formatMessage,
) {
  if (dependentStatus === DEPENDENT_STATUSES.PENDING) {
    return {
      title: formatMessage({ id: 'healthboard.title.dependentPending' }),
      text: formatMessage({ id: 'healthboard.text.dependentPending' }),
      icon: 'pending',
    };
  }
  if (dependentStatus === DEPENDENT_STATUSES.UNVERIFIED) {
    return {
      title: formatMessage({ id: 'healthboard.title.dependentUnverified' }),
      text: formatMessage({ id: 'healthboard.text.dependentUnverified' }),
      icon: 'unverified',
    };
  }
  if (upcomingCounter === 0 && completedCounter === 0) {
    return {
      title: formatMessage({ id: 'healthboard.title.surveysEmpty' }),
      text: formatMessage({ id: 'healthboard.text.surveysEmpty' }),
      icon: 'up-surveys',
    };
  }

  if (upcomingCounter === 0 && completedCounter > 0) {
    return {
      title: formatMessage({ id: 'healthboard.title.surveysCompleted' }),
      text: formatMessage({ id: 'healthboard.text.surveysCompleted' }),
      icon: 'up-surveys',
    };
  }
}

export function getFirstName(targetUser) {
  const displayableName = get(targetUser, 'displayableName') || '';
  const firstName = head(displayableName.split(' '));

  return firstName ? `${firstName}'s` : '';
}

export function getFullName({ username, firstName, lastName } = {}) {
  if (!firstName && !lastName) {
    return `${username}`;
  }

  return `${firstName} ${lastName}`;
}

export const isCompleted = status => status === TODO_STATUSES.COMPLETED;



// WEBPACK FOOTER //
// ./src/components/Healthboard/utils/index.js